import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import settingsIcon from '../../../../images/icons/settings.svg';
import infoIcon from '../../../../images/icons/info.svg';
import streamIcon from '../../../../images/icons/streaming-white-circle.svg';
import playIcon from '../../../../images/icons/play.svg';
import pauseIcon from '../../../../images/icons/pause.svg';
import { SetComponentLanguage, ApiRequest, ReturnTimeZone } from '../../../../helpers';
import AlertModal from '../../../Common/AlertModal/AlertModal';
import { DymoPrint } from '../../../../lib/labels/DYMO.print';
import LocalizedStrings from 'react-localization';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import Player from '@vimeo/player';
import en from './locales/en.json';
import fr from './locales/fr.json';


const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventPoster extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isEventSettingsOpen: false,
            isModalOpen: false,
            targetUserId: null,
            isVideoPlaying: false,
        }
    }

    componentWillReceiveProps(props) {
        
    }
    
    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.destroy()
        }
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    playVideo = () => {
        if (!isMobile) {
            if (this.player) {
                this.player.play()
            } else {
                if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
                    if (this.props.event.poster_vimeo_video_id) {
                        this.player = new Player(`poster-${this.props.event.id}`, {
                            id: this.props.event.poster_vimeo_video_id,
                            width: '100%',
                            height: '100%',
                            autoplay: true,
                            muted: false,
                            controls: false,
                            loop: true,
                        });
                        this.player.play();
                    }
                }
            }
            this.setState({
                isVideoPlaying: true,
            });
        }
    }

    stopVideo = () => {
        if (!isMobile) {
            if (this.player) {
                this.player.pause()
            }
            this.setState({
                isVideoPlaying: false,
            });
        }
    }

    toggleVideo = () => {
        if (isMobile) {
            this.setState({
                isVideoPlaying: !this.state.isVideoPlaying,
            }, () => {
                if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
                    if (this.props.event.poster_vimeo_video_id) {
                        this.player = new Player(`poster-${this.props.event.id}`, {
                            id: this.props.event.poster_vimeo_video_id,
                            width: '100%',
                            height: '100%',
                            autoplay: true,
                            muted: false,
                            controls: false,
                            loop: true,
                        });
                        this.state.isVideoPlaying ? this.player.play() : this.player.pause();
                    }
                }
            });
        }
    }

    toggleAlertModal = (e) => {
        e.preventDefault();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
    }

    confirmAlertModal = async () => {
        try {
            const responseVenue = await getVenue(this.props.event.venue_id);
            console.log('Get Event Venue: ', responseVenue);
            DymoPrint(this.props.currentPrinter, 'sig');
            this.setState({
                isModalOpen: false
            });
        } catch (error) {
            console.log(error);
        }

        async function getVenue(venueId) {
            return await ApiRequest(`/venues/${venueId}`);
        }
    }

    toggleEventSettings = () => {
        let isEventSettingsOpen = this.state.isEventSettingsOpen;
        isEventSettingsOpen = !isEventSettingsOpen;
        this.setState(
            {
                isEventSettingsOpen
            },
            () => {
                // Accessibility - If isEventSettingsOpen, put focus to the Settings menu
                if (this.state.isEventSettingsOpen) {
                    setTimeout(() => {
                        document.getElementById(`event-settings-${this.props.event.id}`).setAttribute('tabIndex', -1);
                        document.getElementById(`event-settings-${this.props.event.id}`).focus;
                    }, 500);
                } else {
                    document.getElementById(`event-settings-${this.props.event.id}`).removeAttribute('tabIndex');
                }
            }
        );
    }

    handleClick = (e) => {
        if (this.node && this.node.contains(e.target) || 
                e.target.id === `poster-settings-b-${this.props.event.id}` || 
                    e.target.id === `poster-settings-i-${this.props.event.id}`) {
            return;
        }
        this.handleClickOutside();
    }

    handleClickOutside = () => {
        if (this.state.isEventSettingsOpen) {
            const isEventSettingsOpen = false;
            this.setState({ isEventSettingsOpen });
        }
    }

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    renderBadge = () => {
        const event = this.props.event;
        if (event.event_type !== 'Video On Demand' && event.event_type !== 'Live Stream' && event.event_type !== 'Scheduled Content') {
            switch (event.venue.venue_type) {
                case 'general-admission':
                    return <div className="showtix-badge showtix-background__primary-2">{strings.generalAdmission}</div>;

                case 'reserved':
                    return <div className="showtix-badge showtix-background__primary-2">{strings.reservedSeating}</div>;

                default:
                    return <div className="showtix-badge showtix-background__primary-2">{strings.generalAdmission}</div>;
            }
        } else {
            return <div className="showtix-badge showtix-background__primary-2">{event.event_type}</div>;
        }
    }

    goToStreamPlayer = () => {
        this.setState({
            isVideoPlaying: false,
        });
        window.open('/stream/');
    }

    renderPlayerButton = () => {
        if (this.props.user.role === undefined) {
            if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content' && this.props.event.poster_vimeo_video_id) {
                return (
                    <button
                        onClick={() => this.goToStreamPlayer()}
                        className="showtix-event__settings"
                        target="_blank"
                        aria-label="Click here to go to the stream player in a new window"
                    >
                        <img
                            src={streamIcon} alt=""
                        />
                    </button>
                );
            }
        } else {
            return null;
        }
    }

    renderVideo = () => {
        if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
            return (
                <div className="showtix-event__poster__video">
                    <div id={`poster-${this.props.event.id}`}>
                        <div className="loader"></div>
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }

    isTodayAfterEventDates = () => {
        if (this.props.event.venue) {
            const timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
            let localUTC = moment().utc();
            let todayIsAfterEventDates = false;
            const events_dates = this.props.event.event_dates
            for(let i = 0; i < events_dates.length; i++) {
                let timeStringEvent = events_dates[i].event_datetime_local.substring(0, 16).replace('T', ' ');
                let venueDateTimeUTCEvent = moment.tz(timeStringEvent, timezone).utc();
                if(localUTC.isAfter(venueDateTimeUTCEvent)){
                    todayIsAfterEventDates = true;
                    break;
                }
            }
            return todayIsAfterEventDates;
        }
    }

    startTour = () => {
        this.setState({
            isEventSettingsOpen: false,
        });
        this.props.startTour();
    }

    render() { 
        let editLink = `/event/${this.props.event.id}`;
        return ( 
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.props.toggleAlertModal}
                    confirmAlertModal={this.props.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.props.printerSelect()}
                    disabled={this.props.printers.length < 1}
                />
                
                <div className={this.state.isVideoPlaying ? `showtix-event__poster is-hover` : `showtix-event__poster`}>
                    {this.renderBadge()}
                    <div className="showtix-event__bar">
                        {this.renderPlayerButton()}
                        
                        {
                            this.props.user.role !== undefined && (this.props.user.client_id === this.props.current_client_id || !this.props.current_client_id) &&
                            <button
                                id={`poster-settings-b-${this.props.event.id}`}
                                className="showtix-event__settings"
                                onClick={this.toggleEventSettings}
                                aria-label='Toggle Event Settings'
                                aria-expanded={this.state.isEventSettingsOpen}
                                aria-controls={`event-settings-${this.props.event.id}`}
                            >
                                <img
                                    id={`poster-settings-i-${this.props.event.id}`}
                                    src={settingsIcon}
                                    alt=""
                                />
                            </button>
                        }
                        {isMobile && (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') && (this.props.event.poster_vimeo_video_id) && (
                            <button
                                className="showtix-event__trailer"
                                onClick={() => this.toggleVideo()}
                                aria-label="Toggle the trailer"
                            >
                                <img
                                    src={this.state.isVideoPlaying ? pauseIcon : playIcon} alt=""
                                />
                            </button>
                        )}
                        
                        <button
                            className="showtix-event__info"
                            onClick={() => this.props.toggleDetails(this.props.event.id)}
                            id={this.props.event.id}
                            aria-label="Toggle Event Details modal"
                            aria-expanded={false}
                            aria-controls=""
                        >
                            <img src={infoIcon} alt="" />
                        </button>
                    </div>
                <div
                    ref={node => this.node = node}
                    id={`event-settings-${this.props.event.id}`}
                    className={"showtix-event__panel showtix-event__settings__panel showtix-background__grey-3" + (this.state.isEventSettingsOpen ? ' is-active' : '')}>
                        {(() => {
                            switch (this.props.event.status) {
                                case 'active':
                                    return  (
                                        <ul>
                                            {this.props.user.role !== 'box-office' &&
                                                <li><Link to={editLink}>{strings.edit}</Link></li>
                                            }
                                            {(this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content' || this.props.event.event_type === 'Video On Demand') && (
                                                <li><Link to={`/upload/${this.props.event.id}`} target="_blank">{strings.videoUpload}</Link></li>
                                            )}
                                            {(this.props.event.event_type === 'Live Stream') && (
                                                <React.Fragment>
                                                    <li>
                                                        {this.props.client && !this.props.client.verified && (
                                                            <React.Fragment>
                                                                <span id="tooltip-verified" className="showtix-tooltip">!</span>
                                                                <Tooltip placement="top" target="tooltip-verified">
                                                                    You need to be verified before setting up your Rehearsal video
                                                                </Tooltip>
                                                            </React.Fragment>
                                                        )}
                                                        <button
                                                            disabled={this.props.client && !this.props.client.verified}
                                                            onClick={() => this.props.getRehearsalCredentials(this.props.event.id, true)}
                                                        >
                                                            {strings.rehearsalCredentials}
                                                        </button>
                                                        
                                                    </li>
                                                    <li>
                                                        <button
                                                            onClick={() => this.startTour()}
                                                        >
                                                            {strings.credentials}
                                                        </button>
                                                        
                                                    </li>
                                                    {/* <li>
                                                        <Link to={`/stream/?vimeoid=${this.props.rehearsal.vimeo_video_id}&eventid=${this.props.event.id}&eventType=${this.props.event.event_type.toLowerCase().replace(/\s/g, '-')}`} target="_blank">{strings.rehearsalStream}</Link>
                                                    </li> */}
                                                </React.Fragment>
                                            )}
                                            <li><Link to={`/search/event/${this.props.event.id}`}>{strings.transactionsSearch}</Link></li>
                                            {this.props.user.role !== 'box-office' &&
                                                <React.Fragment>
                                                    <li>
                                                        <button 
                                                            disabled={this.isTodayAfterEventDates()}
                                                            onClick={(e) => this.props.toggleConfirmEarlyPayout(this.props.event.id)}
                                                        >
                                                            {strings.earlyPayoutRequest}
                                                        </button>
                                                    </li>
                                                    <li><button
                                                            onClick={() => this.props.getAccountEventReport(this.props.event.id, 'event')}
                                                        >{strings.accountReport}</button></li>
                                                    {(this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') && (
                                                        <React.Fragment>
                                                            <li>
                                                                <button
                                                                    onClick={() => this.props.getStreamAccessReport(this.props.event.id)}
                                                                >{strings.streamAccessReport}</button>
                                                            </li>
                                                        </React.Fragment>
                                                    )}
                                                    <li><button
                                                            onClick={() => this.props.getTicketPriceSummary(this.props.event.id)}
                                                        >{strings.ticketPriceSummary}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getTicketBreakdown(this.props.event.id)}
                                                        >{strings.ticketPricingBreakdown}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getQuestionTagReport(this.props.event.id)}
                                                        >{strings.questionTagReport}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getArtistCreditReport(this.props.event.id)}
                                                        >{strings.artistCreditReport}</button></li>
                                                </React.Fragment>    
                                            }
                                            {(this.props.event.event_type !== 'Live Stream' && this.props.event.event_type !== 'Scheduled Content' && this.props.event.event_type !== 'Video On Demand') && (
                                                <React.Fragment>
                                                    <li>
                                                        <button
                                                            onClick={() => this.props.getVenueSeatLabel(this.props.event.venue.id)}
                                                        >{strings.venueSeatLabelsAvery}</button>
                                                    </li>
                                                </React.Fragment>
                                            )}
                                            <li><button
                                                onClick={() => this.props.toggleWidgetModal(this.props.event)}
                                                >{strings.embedEventList}</button>
                                            </li>
                                            {this.props.user.role !== 'box-office' &&
                                                <li><button
                                                        disabled={this.isTodayAfterEventDates()}
                                                        onClick={() => this.props.toggleConfirmDeleteEvent(this.props.event.id)}
                                                    >{strings.delete}</button>
                                                </li>
                                            }
                                        </ul>
                                    );
                                        
                                case 'pending':
                                    return (
                                        <ul>
                                            { this.props.user.role !== 'box-office' &&
                                                <React.Fragment>
                                                    <li><Link to={editLink}>{strings.edit}</Link></li>
                                                    <li>
                                                        <button
                                                            onClick={() => this.props.toggleConfirmDeleteEvent(this.props.event.id)}
                                                        >{strings.delete}</button>
                                                    </li>
                                                </React.Fragment>    
                                            }
                                            {this.props.user.role !== 'box-office' && (this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content' || this.props.event.event_type === 'Video On Demand') && (
                                                <li><Link to={`/upload/${this.props.event.id}`} target="_blank">{strings.videoUpload}</Link></li>
                                            )}
                                        </ul>
                                    );

                                case 'past':
                                    return (
                                        <ul>
                                            {(!this.props.event.payout_created && this.props.user.role !== 'box-office') && (
                                                <li><Link to={editLink}>{strings.edit}</Link></li>
                                            )}
                                            <li><Link to={`/search/event/${this.props.event.id}`}>{strings.transactionsSearch}</Link></li>
                                            { this.props.user.role !== 'box-office' &&
                                                <React.Fragment>
                                                    <li><button
                                                            onClick={() => this.props.getAccountEventReport(this.props.event.id, 'event')}
                                                        >{strings.accountReport}</button></li>
                                                    {(this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') && (
                                                        <React.Fragment>
                                                            <li>
                                                                <button
                                                                    onClick={() => this.props.getStreamAccessReport(this.props.event.id)}
                                                                >{strings.streamAccessReport}</button>
                                                            </li>
                                                        </React.Fragment>
                                                    )}
                                                    <li><button
                                                            onClick={() => this.props.getTicketPriceSummary(this.props.event.id)}
                                                        >{strings.ticketPriceSummary}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getTicketBreakdown(this.props.event.id)}
                                                        >{strings.ticketPricingBreakdown}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getQuestionTagReport(this.props.event.id)}
                                                        >{strings.questionTagReport}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getArtistCreditReport(this.props.event.id)}
                                                        >{strings.artistCreditReport}</button></li>
                                                </React.Fragment>    
                                            }    
                                        </ul>
                                    );

                                default:
                                    return (
                                        <ul>
                                            {this.props.user.role !== 'box-office' &&
                                                <li><Link to={editLink}>{strings.edit}</Link></li>
                                            }
                                            <li><Link to={`/search/event/${this.props.event.id}`}>{strings.transactionsSearch}</Link></li>
                                            {this.props.user.role !== 'box-office' &&
                                                <React.Fragment>
                                                    <li><button 
                                                            disabled={this.isTodayAfterEventDates()}
                                                            onClick={(e) => this.props.toggleConfirmEarlyPayout(this.props.event.id)}
                                                        >{strings.earlyPayoutRequest}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getAccountEventReport(this.props.event.id, 'event')}
                                                        >{strings.accountReport}</button></li>
                                                    {(this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') && (
                                                        <React.Fragment>
                                                            <li>
                                                                <button
                                                                    onClick={() => this.props.getStreamAccessReport(this.props.event.id)}
                                                                >{strings.streamAccessReport}</button>
                                                            </li>
                                                        </React.Fragment>
                                                    )}
                                                    <li><button
                                                            onClick={() => this.props.getTicketPriceSummary(this.props.event.id)}
                                                        >{strings.ticketPriceSummary}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getTicketBreakdown(this.props.event.id)}
                                                        >{strings.ticketPricingBreakdown}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getQuestionTagReport(this.props.event.id)}
                                                        >{strings.questionTagReport}</button></li>
                                                    <li><button
                                                            onClick={() => this.props.getArtistCreditReport(this.props.event.id)}
                                                        >{strings.artistCreditReport}</button></li>
                                                </React.Fragment>    
                                            }        
                                            <li><button
                                                    onClick={() => this.props.getVenueSeatLabel(this.props.event.venue.id)}
                                                >{strings.venueSeatLabelsAvery}</button>
                                            </li>
                                            {/* <li><button
                                                onClick={() => this.props.toggleWidgetModal(this.props.event.id)}
                                                >{strings.embedEventList}</button>
                                            </li> */}
                                            {this.props.user.role !== 'box-office' &&
                                                <li><button
                                                        disabled={this.isTodayAfterEventDates()}
                                                        onClick={() => this.props.toggleConfirmDeleteEvent(this.props.event.id)}
                                                    >{strings.delete}</button>
                                                </li>
                                            }
                                        </ul>
                                    );
                            }
                        })()}
                </div>
                <Link to={`/event-details/${this.props.event.id}`}
                    onMouseOver={() => this.playVideo()}
                    onMouseOut={() => this.stopVideo()}
                    className="showtix-event__poster__link"
                    aria-label={`Go to ${this.props.event.name} Details page`}
                >
                    {!this.props.event.poster_graphic_url &&
                        <div className="showtix-event__poster__title">
                            {ReactHtmlParser(this.props.event.name)}
                        </div>
                    }
                    <div className="showtix-event__poster__image">
                        {this.props.event.poster_graphic_url ?
                            <img src={this.props.event.poster_graphic_url} alt='' />
                            :
                            <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} alt='' />
                        }
                    </div>
                    {this.renderVideo()}
                </Link>
                </div>
            </React.Fragment>
         )
    }
}

EventPoster.propTypes = {
    event: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.number,
        status: PropTypes.string,
        poster_graphic_url: PropTypes.string,
        name: PropTypes.string
    }),
    is_client: PropTypes.bool,
    toggleConfirmDeleteEvent: PropTypes.func,
    toggleDetails: PropTypes.func
}
 
export default EventPoster;


// WEBPACK FOOTER //
// ./src/components/EventListing/Event/EventPoster/EventPoster.js